import { StrictMode } from "react"

import { createRoot } from "react-dom/client"
import { Router } from "wouter"

import App from "./App.tsx"
import { initI18n } from "./i18n/config.ts"
import { useSkipassStore } from "./store/skipassStore"
import { MicroFrontendProps } from "./types/MicroFrontend"

const getDefaultBasePath = (): string => {
  const path = window.location.pathname
  const idx = path.indexOf("/skipass")
  return idx !== -1 ? path.substring(0, idx + "/skipass".length) : "/"
}

const render = (target: string, props: MicroFrontendProps) => {
  const container = document.getElementById(target)
  if (!container) {
    throw new Error(`Container with id "${target}" not found`)
  }

  initI18n(props.locale)
  useSkipassStore.getState().setHostConfig(props.hostConfig)

  const basePath = props.basePath ?? getDefaultBasePath()

  const root = createRoot(container)
  root.render(
    <StrictMode>
      <Router base={basePath}>
        <App />
      </Router>
    </StrictMode>
  )
}

export default render
